import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, InputControl } from '@si-armes/dsfr-react';
import { useFormContext } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import { REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU } from 'constants/contraintes.constants';
import { MESSAGE_DATE_INVALIDE } from 'constants/messagePersonalise.constants';
import { getMessageErreurChampManquant, getPatternHookFormValidation } from 'utils/utils';

const ChampsCarteCollectionneur = ({ validateDate }) => {
    const { register, formState } = useFormContext();

    const validateDateCarteCollectionneur = (dateValue) => {
        if (dateValue && dateValue.length === 10) {
            const dateSplit = dateValue.split('/');
            const dateDelivrance = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
            const today = new Date();
            const fifteenYearsAgo = new Date();
            fifteenYearsAgo.setFullYear(today.getFullYear() - 15);

            if (dateDelivrance < fifteenYearsAgo) {
                return "Votre carte de collectionneur n'est plus valide. Veuillez la renouveler avant de créer un compte dans le SIA";
            }

            if (dateDelivrance > today) {
                return MESSAGE_DATE_INVALIDE;
            }
        }
        return null;
    };

    return (
        <>
            <Row gutters className="margin-top-md">
                <Col col={12}>
                    <p>
                        Si vous ne possédez pas encore une carte de collectionneur, vous devez
                        entreprendre les démarches nécessaires pour en obtenir une. Sans carte de
                        collectionneur valide, la création de compte SIA en qualité de
                        collectionneur n'est pas possible.
                    </p>
                </Col>
            </Row>
            <Row gutters horizontalAlign="center" verticalAlign="bottom">
                <Col col={12} lg={6}>
                    <InputControl
                        id="numeroCarteCollectionneur"
                        label="Numéro de carte collectionneur *"
                        hintText="Caractères numériques et alphabétiques autorisés"
                        required
                        uppercase
                        {...register('numeroCarteCollectionneur', {
                            required: getMessageErreurChampManquant(
                                'numéro de carte collectionneur',
                            ),
                            pattern: {
                                value: /^[a-zA-Z0-9]*$/,
                                message: 'Seuls les caractères alphanumériques sont autorisés',
                            },
                        })}
                        state={formState.errors?.numeroCarteCollectionneur ? 'error' : null}
                        message={formState.errors?.numeroCarteCollectionneur?.message}
                        maxLength="50"
                    />
                </Col>
                <Col col={12} lg={6}>
                    <InputControl
                        id="dateDelivranceCarteCollectionneur"
                        label="Date de délivrance de la carte collectionneur *"
                        required
                        hintText="Exemple : 01/02/1999"
                        {...register('dateDelivranceCarteCollectionneur', {
                            required: getMessageErreurChampManquant(
                                'Date de délivrance de la carte collectionneur',
                            ),
                            pattern: getPatternHookFormValidation(
                                REGEXP_DATE_AVEC_MOIS_JOUR_INCONNU,
                                '',
                                MESSAGE_DATE_INVALIDE,
                            ),
                            validate: {
                                validateDate: (value) => validateDate(value),
                                validateDateCarteCollectionneur: (value) =>
                                    validateDateCarteCollectionneur(value),
                            },
                        })}
                        state={formState.errors?.dateDelivranceCarteCollectionneur ? 'error' : null}
                        message={formState.errors?.dateDelivranceCarteCollectionneur?.message}
                        maskFonction={getDateFormatWithSlash}
                    />
                </Col>
            </Row>
            <Row gutters>
                <Col col={12} lg={6}>
                    <InputFiles
                        name="carteCollectionneur"
                        label="Carte de collectionneur"
                        hintText="Taille max 5 Mo, formats : .png, .pdf, .jpeg, .jpg"
                        error={formState.errors ? formState.errors.carteCollectionneur : null}
                        required
                        accept=".png,.pdf,.jpeg,.jpg"
                        maxSize={5}
                    />
                </Col>
            </Row>
        </>
    );
};

ChampsCarteCollectionneur.propTypes = {
    validateDate: PropTypes.func.isRequired,
};

export default ChampsCarteCollectionneur;
